// built in
import PropTypes from 'prop-types'
import React, { useCallback, useContext, useState } from 'react'
import { nanoid } from 'nanoid'
//external
import { Button, Modal, Select, Space, Steps } from 'antd';
import { Fileuploader } from '@ap-evolved/evolved-ui.ui.fileuploader'
//internal
import FilterContext from './FilterContext'
import dashboardClient from "../../utils/dashboardClient";
import styles from "./styles";

const { Step } = Steps

const UploadModal = ({
    showModal,
    setShowModal
}) => {
    const { afterUpload, clientName } = useContext(FilterContext)
    const currentClient = clientName // dashboardClient.getSelectedClient()
    const clientObject = dashboardClient.getClientObject(clientName)
    const [selectedClient, setSelectedClient] = useState(currentClient)
    const [currentStep, setCurrentStep] = useState(0)

    const generateFileName = () => {
        return `uploads/sensika_${nanoid()}_${selectedClient}`
    }

    const handleCancel = useCallback(() => {
        setShowModal(false)
        setCurrentStep(0)
        setSelectedClient(currentClient)
    })

    const handleAfterUpload = useCallback(() => {
        setTimeout(() => {
            setShowModal(false)
            afterUpload()
        }, 500)
    })

    /**
     * different views for different steps of the modal
     * @type {[{stepKey: number, footer: JSX.Element, title: string, content: JSX.Element}, {stepKey: number, footer: JSX.Element[], title: (string|string), content: JSX.Element}]}
     */
    const steps = [
        {
            stepKey: 0,
            title: 'Select a client',
            content: <Select
                value={selectedClient}
                showSearch
                onChange={setSelectedClient}
                placeholder="Select a client"
                options={dashboardClient.getClientList()}
                style={{ width: '100%' }}
            />,
            footer: <Button
                type="primary"
                style={{
                    ...styles.button(),
                    borderRadius: '20px',
                    width: '20%'
                }}
                onClick={() => {
                    if (selectedClient) setCurrentStep(currentStep + 1)
                }}
            >Next</Button>
        },
        {
            stepKey: 1,
            title: selectedClient ? `Upload file for ${(clientObject.label)}` : 'Upload file',
            content: <>
                <Fileuploader
                    uploadUrl={process.env.REACT_APP_FILE_API_GCP}
                    processApi={"/upload"}
                    maxFiles={1}
                    bucketName={process.env.REACT_APP_UPLOAD_BUCKET}
                    fieldName='file'
                    acceptedFileTypes={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
                    onProcessComplete={handleAfterUpload}
                    fileName={generateFileName()}
                    renameFile={true}
                />
            </>,
            footer: [
                <Button
                    key="prev"
                    type="text"
                    style={{
                        ...styles.button(),
                        borderRadius: '20px',
                        width: '20%'
                    }}
                    onClick={() => { setCurrentStep(currentStep - 1) }}
                >
                    Previous
                </Button>,
                <Button
                    key="next"
                    type="primary"
                    onClick={() => { }}
                    style={{
                        ...styles.button(),
                        borderRadius: '20px',
                        width: '20%'
                    }}
                >
                    Done
                </Button>
            ]
        }
    ]

    return (
        <Modal
            title='Upload new data'
            visible={showModal}
            onOk={() => {
            }}
            onCancel={handleCancel}
            footer={steps[currentStep].footer}
            destroyOnClose
        >
            <Space
                direction="vertical"
                size="large"
                style={{ width: '100%' }}
            >
                <Steps current={currentStep}>
                    {steps.map(step => (<Step key={step.stepKey} title={step.title} />))}
                </Steps>
                {steps[currentStep].content}
            </Space>
        </Modal>
    )

}

UploadModal.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func
}

UploadModal.defaultProps = {
    showModal: false,
    setShowModal: () => {
    }
}

export default UploadModal